import { Actions } from '../actions/types';
import { ActionTypes as PageActionTypes } from '../actions/page';
import { ActionTypes as ArticleFeedbackActionTypes } from '../actions/articleFeedback';

export type Stage = 'initial' | 'positive' | 'negative' | 'submitted' | 'error';

export type IState = {
  stage: Stage;
  isLoading: boolean;
  isFormSubmitting: boolean;
};

export const initialState: IState = {
  stage: 'initial',
  isLoading: false,
  isFormSubmitting: false,
};

const reducer = (state: IState = initialState, action: Actions): IState => {
  switch (action.type) {
    case PageActionTypes.PAGE_NAV_COMPLETE:
      return initialState;

    case ArticleFeedbackActionTypes.FEEDBACK_REACTION_PRESSED:
      return {
        stage: 'initial',
        isLoading: true,
        isFormSubmitting: false,
      };

    case ArticleFeedbackActionTypes.FEEDBACK_REACTION_SUBMITTED:
      return {
        stage: action.payload.isPositive ? 'positive' : 'negative',
        isLoading: false,
        isFormSubmitting: false,
      };

    case ArticleFeedbackActionTypes.NEGATIVE_FEEDBACK_SUBMIT_SUCCESS:
    case ArticleFeedbackActionTypes.NEGATIVE_FEEDBACK_SKIPPED:
      return {
        stage: 'submitted',
        isLoading: false,
        isFormSubmitting: false,
      };

    case ArticleFeedbackActionTypes.NEGATIVE_FEEDBACK_SUBMIT:
      return {
        stage: 'negative',
        isLoading: false,
        isFormSubmitting: true,
      };

    case ArticleFeedbackActionTypes.FEEDBACK_REACTION_ERROR:
    case ArticleFeedbackActionTypes.NEGATIVE_FEEDBACK_SUBMIT_ERROR:
      return {
        stage: 'error',
        isLoading: false,
        isFormSubmitting: false,
      };
  }
  return state;
};

export default reducer;
